export class NotaFiscalEntradaResumoStruct {
  totalNotas: number;
  capturadasHoje: number;
  emLancamento: number;
  comDivergencia: number;
  lancadasMes: number;
  valorLancadasMes: number;
  valorTotal: number;
  valorEmLancamento: number;
}
